import { useMutation } from '@apollo/client'
import { useCallback } from 'react'
import { gql } from '~/__generated__'
import type { ShareSourceEnum } from '~/__generated__/graphql'

const CREATE_SHARE_TOKEN = gql(`
  mutation createShareToken($shareUrl: String!, $source: ShareSourceEnum!) {
    createShareToken(input: { shareUrl: $shareUrl, source: $source }) {
      shareToken {
        token
      }
    }
  }
`)

export const useShareLink = () => {
  const [createShareToken] = useMutation(CREATE_SHARE_TOKEN)
  const createShareLink = useCallback(async (url: string, source: ShareSourceEnum) => {
    const { data } = await createShareToken({ variables: { shareUrl: url, source } })

    if (!data?.createShareToken?.shareToken?.token) {
      return url
    }

    const token = data.createShareToken.shareToken.token

    return url.includes('?') ? `${url}&shareToken=${token}` : `${url}?shareToken=${token}`
  }, [])

  return { createShareLink }
}
